"use client"

import { RefreshIcon } from "@/app/icons/refresh"
import { Trans } from "@lingui/macro"
import {
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  sonnerToast,
} from "@rarible_int/anaconda_ui_components"
import { wrap } from "@reatom/core"
import { reatomComponent } from "@reatom/react"
import { useMolecule } from "bunshi/react"
import { useEffect } from "react"
import { NftMoleculeReatom } from "../store/nft-store.reatom"

export const RefreshMetaButtonReatom = reatomComponent(() => {
  const { resetMetaAction } = useMolecule(NftMoleculeReatom)

  // Watch status - check if action completed successfully
  const isReady = resetMetaAction.ready()
  const error = resetMetaAction.error()

  // Check if action was just completed (not ready and no error)
  const wasSuccessful = !isReady && !error

  useEffect(() => {
    if (wasSuccessful) {
      sonnerToast(
        <Trans>Refreshing Metadata... It may take a few minutes</Trans>,
      )
    }
  }, [wasSuccessful])

  return (
    <Tooltip>
      <TooltipTrigger
        className="cursor-pointer"
        onClick={wrap(() => resetMetaAction())}
        asChild
      >
        <Button size="icon" variant="ghost">
          <RefreshIcon className="[&&]:h-6 [&&]:w-6" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>
        <Trans>Refresh Metadata</Trans>
      </TooltipContent>
    </Tooltip>
  )
})
